import { DATA_SET_PAGINATION_COUNT } from 'constants/dataSets';
import {
  API_METHODS, DEFAULT_ORDER_BY, QUESTIONNAIRE_STATUS, SHEET_EXAMPLE_FILES_NAME,
} from 'constants/general';
import {
  AI_COMPANIES_INFO,
  AI_COMPANIES_SEARCH,
  MA_GEO_REFRESH_AFFECTED,
  MATERIALITY_ASSESSMENT_APPROVE,
  MATERIALITY_ASSESSMENT_ENUM,
  MATERIALITY_ASSESSMENT_INITIALIZE,
  MATERIALITY_ASSESSMENT_LIST, MATERIALITY_ASSESSMENT_MANAGEMENT,
  MATERIALITY_ASSESSMENT_REJECT,
  MATERIALITY_ASSESSMENT_REQUEST_REVIEW,
  MATERIALITY_BOARDS_UPDATE,
  MATERIALITY_COM_UPDATE,
  MATERIALITY_COMPETITORS_DETAILS,
  MATERIALITY_COMPETITORS_LIST,
  MATERIALITY_CUSTOMERS_VCM,
  MATERIALITY_DISCLOSURES_EXCEL_EXAMPLE,
  MATERIALITY_EMPLOYEES_UPDATE,
  MATERIALITY_GEOGRAPHIC_RISKS_STATE, MATERIALITY_INVESTOR_UPDATE, MATERIALITY_IRO_EMAILS,
  MATERIALITY_IRO_EMAILS_RESEND,
  MATERIALITY_IRO_TEMPLATES,
  MATERIALITY_IRO_TEMPLATES_DUPLICATE,
  MATERIALITY_IRO_TEMPLATES_IMPACTS,
  MATERIALITY_IRO_TEMPLATES_IMPACTS_DETAILS,
  MATERIALITY_IRO_TEMPLATES_IMPACTS_DUPLICATE,
  MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES,
  MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_DETAILS,
  MATERIALITY_IRO_TEMPLATES_RISKS,
  MATERIALITY_IRO_TEMPLATES_RISKS_DETAILS,
  MATERIALITY_QUESTIONNAIRE,
  MATERIALITY_QUESTIONNAIRE_CHARTS,
  MATERIALITY_QUESTIONNAIRE_DETAILS,
  MATERIALITY_QUESTIONNAIRE_GRAPH_POINTS,
  MATERIALITY_RESPONDENT_CREATE_USERS,
  MATERIALITY_RESPONDENT_LIST,
  MATERIALITY_SECTORS_AFFECTED,
  MATERIALITY_STAKEHOLDER_ANALYSIS,
  MATERIALITY_STAKEHOLDER_ANALYSIS_AI,
  MATERIALITY_STAKEHOLDER_ANALYSIS_DETAILS,
  MATERIALITY_STAKEHOLDER_BOARDS,
  MATERIALITY_STAKEHOLDER_COM,
  MATERIALITY_STAKEHOLDER_CUSTOMERS,
  MATERIALITY_STAKEHOLDER_DELETE,
  MATERIALITY_STAKEHOLDER_EMPLOYEES,
  MATERIALITY_STAKEHOLDER_GEO,
  MATERIALITY_STAKEHOLDER_GEO_AFFECTED,
  MATERIALITY_STAKEHOLDER_GEO_AI,
  MATERIALITY_STAKEHOLDER_GEO_CATEGORY,
  MATERIALITY_STAKEHOLDER_GEO_GROUPS,
  MATERIALITY_STAKEHOLDER_GEO_GROUPS_AFFECTED,
  MATERIALITY_STAKEHOLDER_GEO_UPDATE, MATERIALITY_STAKEHOLDER_INVESTOR,
  MATERIALITY_STAKEHOLDER_LIST,
  MATERIALITY_STAKEHOLDER_MEDIA,
  MATERIALITY_STAKEHOLDER_MEDIA_UPDATE,
  MATERIALITY_STAKEHOLDER_NGO,
  MATERIALITY_STAKEHOLDER_NGO_UPDATE,
  MATERIALITY_STAKEHOLDER_SUPPLIERS,
  MATERIALITY_STAKEHOLDER_VCM,
  MATERIALITY_SUPPLIERS_VCM,
  MATERIALITY_TOPIC_REFINEMENT,
  MATERIALITY_TOPIC_REFINEMENT_DETAILS,
  MATERIALITY_TOPIC_REFINEMENT_DISCLOSURES,
  MATERIALITY_TOPIC_REFINEMENT_DISCLOSURES_REGIONS,
  MATERIALITY_TOPIC_REFINEMENT_QUESTIONS,
  MATERIALITY_TOPIC_REFINEMENT_QUESTIONS_COMPANIES,
  MATERIALITY_TOPIC_REFINEMENT_STATE,
  MATERIALITY_TOPIC_REFINEMENT_STATE_2,
  MATERIALITY_TOPIC_REFINEMENT_STATE_3,
  MATERIALITY_TOPIC_REFINEMENT_UPDATE,
  MATERIALITY_TOPIC_REFINEMENT_UPDATE_2,
  MATERIALITY_TOPIC_REFINEMENT_UPDATE_3,
  MATERIALITY_TOPICS_CREATE,
  MATERIALITY_TOPICS_CREATE_DISCLOSURES,
  MATERIALITY_TOPICS_DETAILS,
  MATERIALITY_TOPICS_DETAILS_DISCLOSURES,
  MATERIALITY_TOPICS_EXCEL_EXAMPLE,
  MATERIALITY_TOPICS_IMPORT_DISCLOSURES,
  MATERIALITY_TOPICS_IMPORT_EXCEL,
  MATERIALITY_TOPICS_LIST,
  MATERIALITY_TOPICS_LIST_DISCLOSURES, QUESTIONNAIRE_ANSWERS_CREATE, QUESTIONNAIRE_LINK_CREATE, QUESTIONNAIRE_SHARE,
} from 'constants/requestUrls';
import mainApi from 'store/apis/mainApi';
import MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG, {
  MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG, MATERIAL_STAKEHOLDER_BOARDS_TAG,
  MATERIAL_STAKEHOLDER_COMMUNITIES_TAG,
  MATERIAL_STAKEHOLDER_COMPETITORS_TAG,
  MATERIAL_STAKEHOLDER_CUSTOMERS_TAG,
  MATERIAL_STAKEHOLDER_EMPLOYEES_TAG, MATERIAL_STAKEHOLDER_GEO_TAG, MATERIAL_STAKEHOLDER_INVESTOR_TAG,
  MATERIAL_STAKEHOLDER_MEDIA_TAG,
  MATERIAL_STAKEHOLDER_NGO_TAG,
  MATERIAL_STAKEHOLDER_SUPPLIERS_TAG,
  MATERIALITY_IRO_EMAILS_TAG,
  MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG,
  MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG,
  MATERIALITY_IRO_TEMPLATES_RISKS_TAG,
  MATERIALITY_RESPONDENT_LIST_TAG,
  MATERIALITY_STAKEHOLDER_ANALYSIS_TAG,
  MATERIALITY_TOPIC_REFINEMENT_TAG,
  MATERIALITY_TOPICS_LIST_DISCLOSURES_DETAILS_TAG,
  MATERIALITY_TOPICS_LIST_DISCLOSURES_TAG,
  MATERIALITY_TOPICS_LIST_TAG,
} from 'store/tags/materialAssessment';
import downloadFileHandler from 'utils/downloadFileHandler';

import type ICustomerItem from 'store/slices/dataSets/interfaces/ICustomerItem';
import type ISupplierItem from 'store/slices/dataSets/interfaces/ISupplierItem';
import type IDeleteStandardTopicCustomRequest from 'store/slices/standards/interfaces/IDeleteStandardTopicCustomRequest';
import type IStandardCurrentRequest from 'store/slices/standards/interfaces/IStandardCurrentRequest';
import type { IBaseQueryPaginationResponse } from 'store/types/IBaseQueryPaginationResponse';
import type IBaseQueryResponse from 'store/types/IBaseQueryResponse';
import type { ILinkCreateRequest } from '../../survey/interfaces/ISurveyRequests';
import type IIRORecipientRequest from '../IIRORecipientRequest';
import type IChartItem from '../interfaces/IChartItem';
import type IChartRequest from '../interfaces/IChartRequest';
import type { ICheckGroupQuestionsRequest } from '../interfaces/ICheckGroupQuestionsRequest';
import type ICompanyDetails from '../interfaces/ICompanyDetails';
import type ICompanyDetailsRequest from '../interfaces/ICompanyDetailsRequest';
import type ICompanyItem from '../interfaces/ICompanyItem';
import type ICompanySearchRequest from '../interfaces/ICompanySearchRequest';
import type ICreateGeoRiskRequest from '../interfaces/ICreateGeoRiskRequest';
import type ICustomerRecordMARequest from '../interfaces/ICustomerRecordMARequest';
import type IDeleteMARequest from '../interfaces/IDeleteMARequest';
import type IDeleteMAStakeholderRequest from '../interfaces/IDeleteMAStakeholderRequest';
import type IDisclosureCreateRequest from '../interfaces/IDisclosureCreateRequest';
import type IDisclosureItem from '../interfaces/IDisclosureItem';
import type IDownloadExampleQuestionsRequest from '../interfaces/IDownloadExampleQuestionsRequest';
import type IEmployeesEnumItem from '../interfaces/IEmployeesEnumItem';
import type IGeoRiskAffectedGroupItem from '../interfaces/IGeoRiskAffectedGroupItem';
import type IGeoRiskAffectedGroupRequest from '../interfaces/IGeoRiskAffectedGroupRequest';
import type IGeoRiskAnalyzeItem from '../interfaces/IGeoRiskAnalyzeItem';
import type IGeoRiskCategoryItem from '../interfaces/IGeoRiskCategoryItem';
import type IGeoRiskCategoryRequest from '../interfaces/IGeoRiskCategoryRequest';
import type IGeoRiskItem from '../interfaces/IGeoRiskItem';
import type IGroupQuestionDetailsRequest from '../interfaces/IGroupQuestionDetailsRequest';
import type IGroupQuestionsItem from '../interfaces/IGroupQuestionsItem';
import type IImpactTemplateDuplicateRequest from '../interfaces/IImpactTemplateDuplicateRequest';
import type IIROAnswersCreateRequest from '../interfaces/IIROAnswersCreateRequest';
import type IIROCreateLinkResponse from '../interfaces/IIROCreateLinkResponse';
import type IIRODeleteTemplateRequest from '../interfaces/IIRODeleteTemplateRequest';
import type IIROEmailResendRequest from '../interfaces/IIROEmailResendRequest';
import type IIROImpactItem from '../interfaces/IIROImpactItem';
import type IIROImpactRequest from '../interfaces/IIROImpactRequest';
import type IIROItemScore from '../interfaces/IIROItemScore';
import type IIRORecipientEmail from '../interfaces/IIRORecipientEmail';
import type IIROTemplateRequest from '../interfaces/IIROTemplateRequest';
import type IIROTemplatesRequest from '../interfaces/IIROTemplatesRequest';
import type IMAInitialCreateRequest from '../interfaces/IMAInitialCreateRequest';
import type IMAInitialCreateResponse from '../interfaces/IMAInitialCreateResponse';
import type IMAInitialInitializeRequest from '../interfaces/IMAInitialInitializeRequest';
import type IMaterialAssessmentItem from '../interfaces/IMaterialAssessmentItem';
import type IMaterialAssessmentListRequest from '../interfaces/IMaterialAssessmentListRequest';
import type IMaterialitySHBoardsCreateRequest from '../interfaces/IMaterialitySHBoardsCreateRequest';
import type IMaterialitySHBoardsUpdateRequest from '../interfaces/IMaterialitySHBoardsUpdateRequest';
import type IMaterialitySHCommunitiesCreateRequest from '../interfaces/IMaterialitySHCommunitiesCreateRequest';
import type IMaterialitySHCommunitiesUpdateRequest from '../interfaces/IMaterialitySHCommunitiesUpdateRequest';
import type IMaterialitySHEmployeesCreateRequest from '../interfaces/IMaterialitySHEmployeesCreateRequest';
import type IMaterialitySHEmployeesUpdateRequest from '../interfaces/IMaterialitySHEmployeesUpdateRequest';
import type IMaterialitySHInvestorsCreateRequest from '../interfaces/IMaterialitySHInvestorsCreateRequest';
import type IMaterialitySHInvestorsCreateResponse from '../interfaces/IMaterialitySHInvestorsCreateResponse';
import type IMaterialitySHInvestorsUpdateRequest from '../interfaces/IMaterialitySHInvestorsUpdateRequest';
import type IMaterialitySHInvestorsUpdateResponse from '../interfaces/IMaterialitySHInvestorsUpdateResponse';
import type IMaterialitySHMediaCreateRequest from '../interfaces/IMaterialitySHMediaCreateRequest';
import type IMaterialitySHMediaUpdateRequest from '../interfaces/IMaterialitySHMediaUpdateRequest';
import type IMaterialitySHNgosCreateRequest from '../interfaces/IMaterialitySHNgosCreateRequest';
import type IMaterialitySHNgosUpdateRequest from '../interfaces/IMaterialitySHNgosUpdateRequest';
import type IMaterialSHBoardItem from '../interfaces/IMaterialSHBoardItem';
import type IMaterialSHBoardsListRequest from '../interfaces/IMaterialSHBoardsListRequest';
import type IMaterialSHCommunitiesItem from '../interfaces/IMaterialSHCommunitiesItem';
import type IMaterialSHEmployeeItem from '../interfaces/IMaterialSHEmployeeItem';
import type IMaterialSHListRequest from '../interfaces/IMaterialSHEmployeesListRequest';
import type IMaterialSHInvestorsItem from '../interfaces/IMaterialSHInvestorsItem';
import type IMaterialSHInvestorsListRequest from '../interfaces/IMaterialSHInvestorsListRequest';
import type IMaterialSHMediaItem from '../interfaces/IMaterialSHMediaItem';
import type IMaterialSHNgosItem from '../interfaces/IMaterialSHNgosItem';
import type IMaterialStakeholder from '../interfaces/IMaterialStakeholder';
import type IMaterialStakeholderItem from '../interfaces/IMaterialStakeholderItem';
import type IMaterialStakeholdersRequest from '../interfaces/IMaterialStakeholdersRequest';
import type IMaterialStakeholdersUpdateRequest from '../interfaces/IMaterialStakeholdersUpdateRequest';
import type IMAUpdateRequest from '../interfaces/IMAUpdateRequest';
import type IMAUpdateResponse from '../interfaces/IMAUpdateResponse';
import type IMAUpdateStatusResponse from '../interfaces/IMAUpdateStatusResponse';
import type IMAUpdateUsersResponse from '../interfaces/IMAUpdateUsersResponse';
import type IQuestionnaireDetailsItem from '../interfaces/IQuestionnaireDetailsItem';
import type IQuestionnaireItem from '../interfaces/IQuestionnaireItem';
import type IQuestionnaireRequest from '../interfaces/IQuestionnaireRequest';
import type IQuestionsCreateRequest from '../interfaces/IQuestionsCreateRequest';
import type IQuestionsExcelRequest from '../interfaces/IQuestionsExcelRequest';
import type IQuestionsItem from '../interfaces/IQuestionsItem';
import type IRecipientCreateRequest from '../interfaces/IRecipientCreateRequest';
import type IRecipientRequest from '../interfaces/IRecipientRequest';
import type IRefinementListItem from '../interfaces/IRefinementListItem';
import type IRefinementQuestionRequest from '../interfaces/IRefinementQuestionRequest';
import type IRespondentRequest from '../interfaces/IRespondentRequest';
import type ISaveSelectedCustomerRequest from '../interfaces/ISaveSelectedCustomerRequest';
import type ISaveSelectedSupplierRequest from '../interfaces/ISaveSelectedSupplierRequest';
import type ISectorRiskAnalyzeItem from '../interfaces/ISectorRiskAnalyzeItem';
import type ISelectedIROTemplatesRequest from '../interfaces/ISelectedIROTemplatesRequest';
import type ISendQuestions from '../interfaces/ISendQuestions';
import type ISingleMA from '../interfaces/ISingleMA';
import type ISingleMARequest from '../interfaces/ISingleMARequest';
import type IStakeholderAnalysisItem from '../interfaces/IStakeholderAnalysisItem';
import type IStakeholderAnalysisUpdateRequest from '../interfaces/IStakeholderAnalysisUpdateRequest';
import type IStakeholderCompetitorItem from '../interfaces/IStakeholderCompetitorItem';
import type IStakeholderCompetitorRecordMARequest from '../interfaces/IStakeholderCompetitorRecordMARequest';
import type IStakeholderCustomerItem from '../interfaces/IStakeholderCustomerItem';
import type IStakeholderGroupsDisclosuresItem from '../interfaces/IStakeholderGroupsDisclosuresItem';
import type IStakeholderGroupsQuestionsItem from '../interfaces/IStakeholderGroupsQuestionsItem';
import type IStakeholderSupplierItem from '../interfaces/IStakeholderSupplierItem';
import type IStandardCurrentAnalyzeRequest from '../interfaces/IStandardCurrentAnalyzeRequest';
import type IStateAI from '../interfaces/IStateAI';
import type IStateRefinement from '../interfaces/IStateRefinement';
import type ISupplierRecordMARequest from '../interfaces/ISupplierRecordMARequest';
import type ITemplateItem from '../interfaces/ITemplateItem';
import type ITopicRefinementItem from '../interfaces/ITopicRefinementItem';
import type ITopicRefinementRequest from '../interfaces/ITopicRefinementRequest';
import type ITopicRefinementUpdateRequest from '../interfaces/ITopicRefinementUpdateRequest';
import type IUpdateAIGeoRiskRequest from '../interfaces/IUpdateAIGeoRiskRequest';

export const materialAssessmentApi = mainApi.injectEndpoints({
  endpoints: (build) => ({
    getMaterialityAssessments: build.query<
    IBaseQueryPaginationResponse<IMaterialAssessmentItem[]>, IMaterialAssessmentListRequest>({
      query: ({
        offset, orderBy, keyword, statuses,
      }) => ({
        url: MATERIALITY_ASSESSMENT_LIST,
        params: {
          ...(orderBy && { orderBy }),
          ...(keyword && { keyword }),
          ...(offset ? { offset } : { offset: 0 }),
          ...(statuses && { statuses }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG, id } as const)), MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG]
          : [MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG]
      ),
    }),
    deleteMaterialityAssessment: build.mutation<void, IDeleteMARequest>({
      query: ({ id }) => ({
        url: MATERIALITY_ASSESSMENT_MANAGEMENT.replace('{id}', `${id}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG],
    }),
    createMAInitial: build.mutation<IBaseQueryResponse<IMAInitialCreateResponse>,
    IMAInitialCreateRequest>({
      query: (data) => ({
        url: MATERIALITY_ASSESSMENT_LIST,
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG],
    }),
    initializeMAInitial: build.mutation<IBaseQueryResponse<IMAInitialCreateResponse>,
    IMAInitialInitializeRequest>({
      query: ({ id }) => ({
        url: MATERIALITY_ASSESSMENT_INITIALIZE.replace('{id}', `${id}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG,
        MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG],
    }),
    updateMA: build.mutation<IBaseQueryResponse<IMAUpdateResponse>,
    IMAUpdateRequest>({
      query: ({ id, data }) => ({
        url: MATERIALITY_ASSESSMENT_MANAGEMENT.replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG,
        { type: MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG, id },
      ],
    }),
    updateUsersJobMA: build.mutation<IBaseQueryResponse<IMAUpdateResponse>,
    IMAUpdateUsersResponse>({
      query: ({ id, data }) => ({
        url: MATERIALITY_ASSESSMENT_MANAGEMENT.replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG,
        { type: MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG, id },
      ],
    }),
    updateStatusMA: build.mutation<IBaseQueryResponse<IMAUpdateResponse>,
    IMAUpdateStatusResponse>({
      query: ({ id, data }) => ({
        url: MATERIALITY_ASSESSMENT_MANAGEMENT.replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG,
        { type: MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG, id },
      ],
    }),
    getSingleMAInitiate: build.query<IBaseQueryResponse<ISingleMA>, ISingleMARequest>({
      query: ({ id }) => ({
        url: MATERIALITY_ASSESSMENT_MANAGEMENT.replace('{id}', `${id}`),
      }),
      providesTags: (result) => (
        result?.data?.id
          ? [{ type: MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG, id: result.data?.id }]
          : [MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG]
      ),
    }),
    getMaterialityStakeholders: build.query<
    IBaseQueryResponse<IMaterialStakeholder>, IMaterialStakeholdersRequest>({
      query: ({
        maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_LIST.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
      }),
    }),
    updateMaterialityStakeholders: build.mutation<
    IBaseQueryResponse<IMaterialStakeholderItem>, IMaterialStakeholdersUpdateRequest>({
      query: ({
        maId, body, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_LIST.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.patch,
        body,
      }),
    }),
    deleteMaterialityStakeholder: build.mutation<void, IDeleteMAStakeholderRequest>({
      query: ({ id, maId }) => ({
        url: MATERIALITY_STAKEHOLDER_DELETE.replace('{id}', `${id}`).replace('{maId}', `${maId}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_SUPPLIERS_TAG,
        MATERIAL_STAKEHOLDER_INVESTOR_TAG,
        MATERIAL_STAKEHOLDER_BOARDS_TAG,
        MATERIAL_STAKEHOLDER_EMPLOYEES_TAG,
        MATERIAL_STAKEHOLDER_COMMUNITIES_TAG,
        MATERIAL_STAKEHOLDER_NGO_TAG,
        MATERIAL_STAKEHOLDER_CUSTOMERS_TAG,
        MATERIAL_STAKEHOLDER_COMPETITORS_TAG,
        MATERIAL_STAKEHOLDER_MEDIA_TAG],
    }),
    deleteVCMaterialityStakeholder: build.mutation<void, IDeleteMAStakeholderRequest>({
      query: ({ id, maId }) => ({
        url: MATERIALITY_STAKEHOLDER_VCM.replace('{id}', `${id}`).replace('{maId}', `${maId}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_SUPPLIERS_TAG,
        MATERIAL_STAKEHOLDER_INVESTOR_TAG,
        MATERIAL_STAKEHOLDER_BOARDS_TAG,
        MATERIAL_STAKEHOLDER_EMPLOYEES_TAG,
        MATERIAL_STAKEHOLDER_COMMUNITIES_TAG,
        MATERIAL_STAKEHOLDER_NGO_TAG,
        MATERIAL_STAKEHOLDER_CUSTOMERS_TAG,
        MATERIAL_STAKEHOLDER_COMPETITORS_TAG,
        MATERIAL_STAKEHOLDER_CUSTOMERS_TAG,
        MATERIAL_STAKEHOLDER_MEDIA_TAG],
    }),
    getMaterialitySHInvestors: build.query<
    IBaseQueryPaginationResponse<IMaterialSHInvestorsItem[]>, IMaterialSHInvestorsListRequest>({
      query: ({
        offset, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_INVESTOR.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_INVESTOR_TAG, id } as const)), MATERIAL_STAKEHOLDER_INVESTOR_TAG]
          : [MATERIAL_STAKEHOLDER_INVESTOR_TAG]
      ),
    }),
    createMaterialitySHInvestors: build.mutation<IBaseQueryResponse<IMaterialitySHInvestorsCreateResponse>,
    IMaterialitySHInvestorsCreateRequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_INVESTOR.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_INVESTOR_TAG],
    }),
    updateMaterialitySHInvestors: build.mutation<IBaseQueryResponse<IMaterialitySHInvestorsUpdateResponse>,
    IMaterialitySHInvestorsUpdateRequest>({
      query: ({
        id, data, maId, vcmId,
      }) => ({
        url: MATERIALITY_INVESTOR_UPDATE.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
    }),
    getMaterialitySHBoards: build.query<
    IBaseQueryPaginationResponse<IMaterialSHBoardItem[]>, IMaterialSHBoardsListRequest>({
      query: ({
        offset, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_BOARDS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_BOARDS_TAG, id } as const)), MATERIAL_STAKEHOLDER_BOARDS_TAG]
          : [MATERIAL_STAKEHOLDER_BOARDS_TAG]
      ),
    }),
    createMaterialitySHBoards: build.mutation<IBaseQueryResponse<IMaterialSHBoardItem>,
    IMaterialitySHBoardsCreateRequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_BOARDS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_BOARDS_TAG],
    }),
    updateMaterialitySHBoards: build.mutation<IBaseQueryResponse<IMaterialSHBoardItem>,
    IMaterialitySHBoardsUpdateRequest>({
      query: ({
        id, data, maId, vcmId,
      }) => ({
        url: MATERIALITY_BOARDS_UPDATE.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
    }),
    getMaterialitySHEmployees: build.query<
    IBaseQueryPaginationResponse<IMaterialSHEmployeeItem[]>, IMaterialSHListRequest>({
      query: ({
        offset, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_EMPLOYEES.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_EMPLOYEES_TAG, id } as const)), MATERIAL_STAKEHOLDER_EMPLOYEES_TAG]
          : [MATERIAL_STAKEHOLDER_EMPLOYEES_TAG]
      ),
    }),
    createMaterialitySHEmployees: build.mutation<IBaseQueryResponse<IMaterialSHEmployeeItem>,
    IMaterialitySHEmployeesCreateRequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_EMPLOYEES.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_EMPLOYEES_TAG],
    }),
    updateMaterialitySHEmployees: build.mutation<IBaseQueryResponse<IMaterialSHEmployeeItem>,
    IMaterialitySHEmployeesUpdateRequest>({
      query: ({
        id, data, maId, vcmId,
      }) => ({
        url: MATERIALITY_EMPLOYEES_UPDATE.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
    }),
    getMaterialitySHCommunities: build.query<
    IBaseQueryPaginationResponse<IMaterialSHCommunitiesItem[]>, IMaterialSHListRequest>({
      query: ({
        offset, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_COM.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_COMMUNITIES_TAG, id } as const)), MATERIAL_STAKEHOLDER_COMMUNITIES_TAG]
          : [MATERIAL_STAKEHOLDER_COMMUNITIES_TAG]
      ),
    }),
    createMaterialitySHCommunities: build.mutation<IBaseQueryResponse<IMaterialSHCommunitiesItem>,
    IMaterialitySHCommunitiesCreateRequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_COM.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_COMMUNITIES_TAG],
    }),
    updateMaterialitySHCommunities: build.mutation<IBaseQueryResponse<IMaterialSHCommunitiesItem>,
    IMaterialitySHCommunitiesUpdateRequest>({
      query: ({
        id, data, maId, vcmId,
      }) => ({
        url: MATERIALITY_COM_UPDATE.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
    }),
    getMaterialitySHNgos: build.query<
    IBaseQueryPaginationResponse<IMaterialSHNgosItem[]>, IMaterialSHListRequest>({
      query: ({
        offset, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_NGO.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_NGO_TAG, id } as const)), MATERIAL_STAKEHOLDER_NGO_TAG]
          : [MATERIAL_STAKEHOLDER_NGO_TAG]
      ),
    }),
    createMaterialitySHNgos: build.mutation<IBaseQueryResponse<IMaterialSHNgosItem>,
    IMaterialitySHNgosCreateRequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_NGO.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_NGO_TAG],
    }),
    updateMaterialitySHNgos: build.mutation<IBaseQueryResponse<IMaterialSHNgosItem>,
    IMaterialitySHNgosUpdateRequest>({
      query: ({
        id, data, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_NGO_UPDATE.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
    }),
    getMaterialitySHMedia: build.query<
    IBaseQueryPaginationResponse<IMaterialSHMediaItem[]>, IMaterialSHListRequest>({
      query: ({
        offset, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_MEDIA.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_MEDIA_TAG, id } as const)), MATERIAL_STAKEHOLDER_MEDIA_TAG]
          : [MATERIAL_STAKEHOLDER_MEDIA_TAG]
      ),
    }),
    createMaterialitySHMedia: build.mutation<IBaseQueryResponse<IMaterialSHMediaItem>,
    IMaterialitySHMediaCreateRequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_MEDIA.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_MEDIA_TAG],
    }),
    updateMaterialitySHMedia: build.mutation<IBaseQueryResponse<IMaterialSHMediaItem>,
    IMaterialitySHMediaUpdateRequest>({
      query: ({
        id, data, maId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_MEDIA_UPDATE.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
    }),
    getGeoRiskList: build.query<
    IBaseQueryPaginationResponse<IGeoRiskItem[]>, IStandardCurrentRequest>({
      query: ({
        offset, maId, orderBy, valueChainMapId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO.replace('{maId}', `${maId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(orderBy && orderBy.length > 0 ? { orderBy } : {}),
          ...(valueChainMapId ? { valueChainMapId } : {}),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_GEO_TAG, id } as const)), MATERIAL_STAKEHOLDER_GEO_TAG]
          : [MATERIAL_STAKEHOLDER_GEO_TAG]
      ),
    }),
    createGeoRisk: build.mutation<IBaseQueryResponse<IGeoRiskItem>,
    ICreateGeoRiskRequest>({
      query: ({ body, maId }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO.replace('{maId}', `${maId}`),
        method: API_METHODS.post,
        body,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_GEO_TAG],
    }),
    deleteGeoRisk: build.mutation<void, IDeleteStandardTopicCustomRequest>({
      query: ({ id, maId }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO_UPDATE.replace('{id}', `${id}`).replace('{maId}', `${maId}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_GEO_TAG],
    }),
    getGeoRiskCategoriesList: build.query<
    IBaseQueryPaginationResponse<IGeoRiskCategoryItem[]>, IGeoRiskCategoryRequest>({
      query: ({
        offset,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO_CATEGORY,
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
    }),
    getStateAIGeoRisk: build.query<IBaseQueryResponse<IStateAI>, IUpdateAIGeoRiskRequest>({
      query: ({ maId, vcmId }) => ({
        url: MATERIALITY_GEOGRAPHIC_RISKS_STATE.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
      }),
      providesTags: [MATERIAL_STAKEHOLDER_GEO_TAG],
    }),
    updateAIGeoRisk: build.mutation<null, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO_AI.replace('{maId}', `${maId}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_GEO_TAG],
    }),
    refreshAIGeoRisk: build.mutation<null, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MA_GEO_REFRESH_AFFECTED.replace('{maId}', `${maId}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_GEO_TAG],
    }),
    getGeoRiskAnalyzeList: build.query<
    IBaseQueryPaginationResponse<IGeoRiskAnalyzeItem[]>, IStandardCurrentAnalyzeRequest>({
      query: ({
        offset, maId, riskId, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO_AFFECTED.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
          riskId,
        },
      }),
      keepUnusedDataFor: 0,
    }),
    getGeoRiskGroups: build.query<
    IBaseQueryResponse<IGeoRiskAffectedGroupItem[]>, IUpdateAIGeoRiskRequest>({
      query: ({ maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO_GROUPS
          .replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`),
      }),
      keepUnusedDataFor: 0,
    }),
    getGeoRiskAffectedGroups: build.query<
    IBaseQueryPaginationResponse<IGeoRiskAnalyzeItem[]>, IGeoRiskAffectedGroupRequest>({
      query: ({
        maId, id, vcmId, offset, orderBy,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_GEO_GROUPS_AFFECTED
          .replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`)
          .replace('{id}', `${id}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(orderBy && orderBy.length > 0 ? { orderBy } : {}),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: [MATERIAL_STAKEHOLDER_GEO_TAG],
      keepUnusedDataFor: 0,
    }),
    getStakeholdersSuppliersList: build.query<
    IBaseQueryPaginationResponse<IStakeholderSupplierItem[]>, IStandardCurrentRequest>({
      query: ({
        offset, maId, valueChainMapId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_SUPPLIERS.replace('{maId}', `${maId}`).replace('{vcmId}', `${valueChainMapId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_SUPPLIERS_TAG, id } as const)), MATERIAL_STAKEHOLDER_SUPPLIERS_TAG]
          : [MATERIAL_STAKEHOLDER_SUPPLIERS_TAG]
      ),
    }),
    saveSelectedSupplier: build.mutation<null,
    ISaveSelectedSupplierRequest>({
      query: ({ data, maId, valueChainMapId }) => ({
        url: MATERIALITY_SUPPLIERS_VCM.replace('{maId}', `${maId}`).replace('{vcmId}', `${valueChainMapId}`),
        method: API_METHODS.post,
        body: { selectedRecords: data },
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_SUPPLIERS_TAG],
    }),
    supplierMACreate: build.mutation <IBaseQueryResponse<ISupplierItem>,
    ISupplierRecordMARequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_SUPPLIERS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_SUPPLIERS_TAG],
    }),
    getStakeholdersCustomersList: build.query<
    IBaseQueryPaginationResponse<IStakeholderCustomerItem[]>, IStandardCurrentRequest>({
      query: ({
        offset, maId, valueChainMapId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_CUSTOMERS.replace('{maId}', `${maId}`).replace('{vcmId}', `${valueChainMapId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_CUSTOMERS_TAG, id } as const)), MATERIAL_STAKEHOLDER_CUSTOMERS_TAG]
          : [MATERIAL_STAKEHOLDER_CUSTOMERS_TAG]
      ),
    }),
    saveSelectedCustomer: build.mutation<null,
    ISaveSelectedCustomerRequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_CUSTOMERS_VCM.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: { selectedRecords: data },
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_CUSTOMERS_TAG],
    }),
    customerMACreate: build.mutation <IBaseQueryResponse<ICustomerItem>,
    ICustomerRecordMARequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_CUSTOMERS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_CUSTOMERS_TAG],
    }),
    getStakeholdersGroupsQuestionsList: build.query<
    IBaseQueryPaginationResponse<IStakeholderGroupsQuestionsItem[]>, IStandardCurrentRequest>({
      query: ({
        offset, maId, valueChainMapId,
      }) => ({
        url: MATERIALITY_TOPICS_LIST.replace('{maId}', `${maId}`).replace('{vcmId}', `${valueChainMapId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_TOPICS_LIST_TAG, id } as const)), MATERIALITY_TOPICS_LIST_TAG]
          : [MATERIALITY_TOPICS_LIST_TAG]
      ),
    }),
    getStakeholdersQuestionsList: build.query<
    IBaseQueryPaginationResponse<IQuestionsItem[]>, IGroupQuestionDetailsRequest>({
      query: ({
        maId, id, vcmId,
      }) => ({
        url: MATERIALITY_TOPICS_DETAILS.replace('{maId}', `${maId}`)
          .replace('{id}', `${id}`).replace('{vcmId}', `${vcmId}`),
      }),
    }),
    importQuestionsExcel: build.mutation <null, IQuestionsExcelRequest>({
      query: ({ maId, url, valueChainMapId }) => ({
        url: MATERIALITY_TOPICS_IMPORT_EXCEL.replace('{maId}', `${maId}`).replace('{vcmId}', `${valueChainMapId}`),
        method: API_METHODS.post,
        body: { url },
      }),
      invalidatesTags: [MATERIALITY_TOPICS_LIST_TAG],
    }),
    checkGroupQuestions: build.mutation <null, ICheckGroupQuestionsRequest>({
      query: ({
        maId, groupIds, isActive, vcmId,
      }) => ({
        url: MATERIALITY_TOPICS_LIST.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(groupIds && groupIds.length > 0 ? { groupIds } : {}),
        },
        method: API_METHODS.patch,
        body: { isActive },
      }),
      invalidatesTags: [],
    }),
    createQuestions: build.mutation <IBaseQueryResponse<IGroupQuestionsItem>, IQuestionsCreateRequest>({
      query: ({ maId, data, vcmId }) => ({
        url: MATERIALITY_TOPICS_CREATE.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_TOPICS_LIST_TAG],
    }),
    getSectorRiskAnalyzeList: build.query<
    IBaseQueryPaginationResponse<ISectorRiskAnalyzeItem[]>, IStandardCurrentAnalyzeRequest>({
      query: ({
        offset, maId, riskId, vcmId,
      }) => ({
        url: MATERIALITY_SECTORS_AFFECTED.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
          riskId,
        },
      }),
    }),
    getCompanySearch: build.query<IBaseQueryResponse<ICompanyItem[]>, ICompanySearchRequest>({
      query: ({
        search,
      }) => ({
        url: AI_COMPANIES_SEARCH,
        params: {
          ...(search ? { search } : { }),
        },
      }),
    }),
    getCompanyDetailsCompetitor: build.query<ICompanyDetails[], ICompanyDetailsRequest>({
      query: ({
        companyNames,
      }) => ({
        url: AI_COMPANIES_INFO,
        params: {
          ...(companyNames && companyNames.length > 0 ? { companyNames } : {}),
        },
      }),
    }),
    getStakeholdersCompetitorsList: build.query<
    IBaseQueryPaginationResponse<IStakeholderCompetitorItem[]>, IStandardCurrentRequest>({
      query: ({
        offset, maId, vcmId,
      }) => ({
        url: MATERIALITY_COMPETITORS_LIST.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIAL_STAKEHOLDER_COMPETITORS_TAG, id } as const)),
          MATERIAL_STAKEHOLDER_COMPETITORS_TAG]
          : [MATERIAL_STAKEHOLDER_COMPETITORS_TAG]
      ),
    }),
    competitorMACreate: build.mutation <IBaseQueryResponse<IStakeholderCompetitorItem>,
    IStakeholderCompetitorRecordMARequest>({
      query: ({ data, maId, vcmId }) => ({
        url: MATERIALITY_COMPETITORS_LIST.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIAL_STAKEHOLDER_COMPETITORS_TAG],
    }),
    deleteCompetitorMA: build.mutation<void, IDeleteStandardTopicCustomRequest>({
      query: ({ id, maId, vcmId }) => ({
        url: MATERIALITY_COMPETITORS_DETAILS.replace('{id}', `${id}`).replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [],
    }),
    getStakeholdersAnalysisList: build.query<
    IBaseQueryPaginationResponse<IStakeholderAnalysisItem[]>, IStandardCurrentRequest>({
      query: ({
        offset, maId, type, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_ANALYSIS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
          ...(type ? { type } : {}),
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_STAKEHOLDER_ANALYSIS_TAG, id } as const)),
          MATERIALITY_STAKEHOLDER_ANALYSIS_TAG]
          : [MATERIALITY_STAKEHOLDER_ANALYSIS_TAG]
      ),
    }),
    analysisAICreate: build.mutation <null,
    IStandardCurrentRequest>({
      query: ({ maId, vcmId }) => ({
        url: MATERIALITY_STAKEHOLDER_ANALYSIS_AI.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [],
    }),
    stakeholderAnalysisUpdate: build.mutation <IBaseQueryResponse<IStakeholderAnalysisItem>,
    IStakeholderAnalysisUpdateRequest>({
      query: ({
        data, maId, id, vcmId,
      }) => ({
        url: MATERIALITY_STAKEHOLDER_ANALYSIS_DETAILS.replace('{maId}', `${maId}`)
          .replace('{id}', `${id}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_STAKEHOLDER_ANALYSIS_TAG],
    }),
    getStakeholdersGroupsDisclosuresList: build.query<
    IBaseQueryPaginationResponse<IStakeholderGroupsDisclosuresItem[]>, IStandardCurrentRequest>({
      query: ({
        offset, maId, valueChainMapId,
      }) => ({
        url: MATERIALITY_TOPICS_LIST_DISCLOSURES.replace('{maId}', `${maId}`).replace('{vcmId}', `${valueChainMapId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_TOPICS_LIST_DISCLOSURES_TAG, id } as const)), MATERIALITY_TOPICS_LIST_DISCLOSURES_TAG]
          : [MATERIALITY_TOPICS_LIST_DISCLOSURES_TAG]
      ),
    }),
    getStakeholdersDisclosuresList: build.query<
    IBaseQueryPaginationResponse<IDisclosureItem[]>, IGroupQuestionDetailsRequest>({
      query: ({
        maId, id, vcmId,
      }) => ({
        url: MATERIALITY_TOPICS_DETAILS_DISCLOSURES.replace('{maId}', `${maId}`)
          .replace('{id}', `${id}`).replace('{vcmId}', `${vcmId}`),
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_TOPICS_LIST_DISCLOSURES_DETAILS_TAG, id } as const)),
          MATERIALITY_TOPICS_LIST_DISCLOSURES_DETAILS_TAG]
          : [MATERIALITY_TOPICS_LIST_DISCLOSURES_DETAILS_TAG]
      ),
    }),
    importDisclosuresExcel: build.mutation <null, IQuestionsExcelRequest>({
      query: ({ maId, url, valueChainMapId }) => ({
        url: MATERIALITY_TOPICS_IMPORT_DISCLOSURES.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${valueChainMapId}`),
        method: API_METHODS.post,
        body: { url },
      }),
      invalidatesTags: [MATERIALITY_TOPICS_LIST_DISCLOSURES_TAG],
    }),
    checkGroupDisclosures: build.mutation <null, ICheckGroupQuestionsRequest>({
      query: ({
        maId, groupIds, isActive, vcmId,
      }) => ({
        url: MATERIALITY_TOPICS_LIST_DISCLOSURES.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(groupIds && groupIds.length > 0 ? { groupIds } : {}),
        },
        method: API_METHODS.patch,
        body: { isActive },
      }),
      invalidatesTags: [],
    }),
    createDisclosure: build.mutation <IBaseQueryResponse<IDisclosureItem>, IDisclosureCreateRequest>({
      query: ({ maId, data, vcmId }) => ({
        url: MATERIALITY_TOPICS_CREATE_DISCLOSURES.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_TOPICS_LIST_DISCLOSURES_DETAILS_TAG],
    }),
    getIROTemplatesList: build.query<
    IBaseQueryPaginationResponse<ITemplateItem[]>, IIROTemplatesRequest>({
      query: ({
        offset, standardId, naceSections, categories,
      }) => ({
        url: MATERIALITY_IRO_TEMPLATES,
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(naceSections && naceSections.length > 0 ? { naceSections } : {}),
          ...(categories && categories.length > 0 ? { categories } : {}),
          limit: DATA_SET_PAGINATION_COUNT,
          standardId,
        },
      }),
    }),
    getIROImpactList: build.query<
    IBaseQueryPaginationResponse<IIROImpactItem[]>, IIROImpactRequest>({
      query: ({
        maId, offset, impact, naceSections, standardId, vcmId,
      }) => ({
        url: MATERIALITY_IRO_TEMPLATES_IMPACTS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(impact ? { impact } : {}),
          ...(naceSections && naceSections.length > 0 ? { naceSections } : {}),
          ...(standardId ? { standardId } : {}),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG, id } as const)),
          MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG]
          : [MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG]
      ),
    }),
    selectedIROTemplates: build.mutation <null, ISelectedIROTemplatesRequest>({
      query: ({ maId, data, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_DUPLICATE.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [
        MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG,
        MATERIALITY_IRO_TEMPLATES_RISKS_TAG,
        MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG,
      ],
    }),
    createCustomIROTemplates: build.mutation <IBaseQueryResponse<IIROImpactItem>, IIROTemplateRequest>({
      query: ({ maId, data, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_IMPACTS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG],
    }),
    updateCustomIROTemplates: build.mutation <IBaseQueryResponse<IIROImpactItem>, IIROTemplateRequest>({
      query: ({
        maId, data, id, vcmId,
      }) => ({
        url: MATERIALITY_IRO_TEMPLATES_IMPACTS_DETAILS.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG],
    }),
    deleteCustomIROTemplates: build.mutation <null, IIRODeleteTemplateRequest>({
      query: ({ maId, id, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_IMPACTS_DETAILS.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [],
    }),
    getIRORisksList: build.query<
    IBaseQueryPaginationResponse<IIROImpactItem[]>, IIROImpactRequest>({
      query: ({
        maId, offset, vcmId,
      }) => ({
        url: MATERIALITY_IRO_TEMPLATES_RISKS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_IRO_TEMPLATES_RISKS_TAG, id } as const)),
          MATERIALITY_IRO_TEMPLATES_RISKS_TAG]
          : [MATERIALITY_IRO_TEMPLATES_RISKS_TAG]
      ),
    }),
    duplicateImpactTemplates: build.mutation <IBaseQueryResponse<IIROImpactItem>, IImpactTemplateDuplicateRequest>({
      query: ({ maId, data, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_IMPACTS_DUPLICATE.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_IRO_TEMPLATES_RISKS_TAG,
        MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG],
    }),
    createCustomRisksTemplates: build.mutation <IBaseQueryResponse<IIROImpactItem>, IIROTemplateRequest>({
      query: ({ maId, data, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_RISKS.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_IRO_TEMPLATES_RISKS_TAG],
    }),
    updateCustomRiskTemplates: build.mutation <IBaseQueryResponse<IIROImpactItem>, IIROTemplateRequest>({
      query: ({
        maId, data, id, vcmId,
      }) => ({
        url: MATERIALITY_IRO_TEMPLATES_RISKS_DETAILS.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_IRO_TEMPLATES_RISKS_TAG],
    }),
    deleteCustomRiskTemplates: build.mutation <null, IIRODeleteTemplateRequest>({
      query: ({ maId, id, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_RISKS_DETAILS.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [],
    }),
    getIROOpportunitiesList: build.query<
    IBaseQueryPaginationResponse<IIROImpactItem[]>, IIROImpactRequest>({
      query: ({
        maId, offset, vcmId,
      }) => ({
        url: MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG, id } as const)),
          MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG]
          : [MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG]
      ),
    }),
    getIROEmailsList: build.query<IBaseQueryPaginationResponse<IIRORecipientEmail[]>, IIRORecipientRequest>({
      query: ({ maId, offset, vcmId }) => ({
        url: MATERIALITY_IRO_EMAILS.replace('{vcmId}', `${vcmId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(maId && { maId }),
          limit: DATA_SET_PAGINATION_COUNT,
          orderBy: DEFAULT_ORDER_BY,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_IRO_EMAILS_TAG, id } as const)),
          MATERIALITY_IRO_EMAILS_TAG]
          : [MATERIALITY_IRO_EMAILS_TAG]
      ),
    }),
    resendEmail: build.mutation<null, IIROEmailResendRequest>({
      query: ({ maId, questionnaireRecipientId }) => ({
        url: MATERIALITY_IRO_EMAILS_RESEND,
        method: API_METHODS.post,
        body: {
          maId,
          questionnaireRecipientId,
        },
      }),
      invalidatesTags: (_result, error) => (error ? [] : [MATERIALITY_IRO_EMAILS_TAG]),
    }),
    createCustomOpportunitiesTemplates: build.mutation <IBaseQueryResponse<IIROImpactItem>, IIROTemplateRequest>({
      query: ({ maId, data, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG],
    }),
    updateCustomOpportunitiesTemplates: build.mutation <IBaseQueryResponse<IIROImpactItem>, IIROTemplateRequest>({
      query: ({
        maId, data, id, vcmId,
      }) => ({
        url: MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_DETAILS.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG],
    }),
    deleteCustomOpportunitiesTemplates: build.mutation <null, IIRODeleteTemplateRequest>({
      query: ({ maId, id, vcmId }) => ({
        url: MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_DETAILS.replace('{maId}', `${maId}`)
          .replace('{vcmId}', `${vcmId}`).replace('{id}', `${id}`),
        method: API_METHODS.delete,
      }),
      invalidatesTags: [],
    }),
    downloadQuestions: build.query<IBaseQueryPaginationResponse<void>, IDownloadExampleQuestionsRequest>({
      query: ({ maId, vcmId }) => ({
        url: MATERIALITY_TOPICS_EXCEL_EXAMPLE.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        responseHandler: async (response) => downloadFileHandler({
          filename: SHEET_EXAMPLE_FILES_NAME.questions,
          response,
        }),
        cache: 'no-cache',
      }),
    }),
    downloadDisclosures: build.query<IBaseQueryPaginationResponse<void>, IDownloadExampleQuestionsRequest>({
      query: ({ maId, vcmId }) => ({
        url: MATERIALITY_DISCLOSURES_EXCEL_EXAMPLE.replace('{maId}', `${maId}`).replace('{vcmId}', `${vcmId}`),
        responseHandler: async (response) => downloadFileHandler({
          filename: SHEET_EXAMPLE_FILES_NAME.disclosures,
          response,
        }),
        cache: 'no-cache',
      }),
    }),
    getIROScoreList: build.query<
    IBaseQueryResponse<IIROItemScore[]>, IStandardCurrentRequest>({
      query: ({
        maId, valueChainMapId,
      }) => ({
        url: MATERIALITY_QUESTIONNAIRE_GRAPH_POINTS.replace('{maId}', `${maId}`),
        params: {
          ...(valueChainMapId ? { valueChainMapId } : { }),
        },
      }),
    }),
    shareIroQuestions: build.mutation<IBaseQueryResponse<null>, ISendQuestions>({
      query: (data) => ({
        url: QUESTIONNAIRE_SHARE,
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: (_result, error) => (error ? [] : [MATERIALITY_IRO_EMAILS_TAG]),
    }),
    IROLinkCreate: build.mutation<IBaseQueryResponse<IIROCreateLinkResponse>, ILinkCreateRequest>({
      query: ({ surveyToken, respondentId }) => ({
        url: QUESTIONNAIRE_LINK_CREATE,
        method: API_METHODS.post,
        params: { token: surveyToken },
        body: { respondentId },
      }),
    }),
    IroAnswersCreate: build.mutation<IBaseQueryResponse<any>, IIROAnswersCreateRequest>({
      query: ({ data, token }) => ({
        url: QUESTIONNAIRE_ANSWERS_CREATE,
        method: API_METHODS.patch,
        body: data,
        params: { token },
      }),
    }),
    getStateTopicRefinement: build.query<IBaseQueryResponse<IStateRefinement>, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_STATE.replace('{maId}', `${maId}`),
      }),
    }),
    getStateTopicRefinement2: build.query<IBaseQueryResponse<IStateRefinement>, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_STATE_2.replace('{maId}', `${maId}`),
      }),
    }),
    getStateTopicRefinement3: build.query<IBaseQueryResponse<IStateRefinement>, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_STATE_3.replace('{maId}', `${maId}`),
      }),
    }),
    updateTopicRefinement: build.mutation <null, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_UPDATE.replace('{maId}', `${maId}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [],
    }),
    updateTopicRefinement2: build.mutation <null, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_UPDATE_2.replace('{maId}', `${maId}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [],
    }),
    updateTopicRefinement3: build.mutation <null, IUpdateAIGeoRiskRequest>({
      query: ({ maId }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_UPDATE_3.replace('{maId}', `${maId}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [],
    }),
    getTopicRefinementList: build.query<
    IBaseQueryPaginationResponse<ITopicRefinementItem[]>, ITopicRefinementRequest>({
      query: ({
        maId, offset, valueChainMapIds,
      }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT.replace('{maId}', `${maId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(valueChainMapIds && valueChainMapIds.length > 0 ? { valueChainMapIds } : { }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_TOPIC_REFINEMENT_TAG, id } as const)),
          MATERIALITY_TOPIC_REFINEMENT_TAG]
          : [MATERIALITY_TOPIC_REFINEMENT_TAG]
      ),
    }),
    updateToggleTopicRefinement: build.mutation <IBaseQueryResponse<ITopicRefinementItem>
    , ITopicRefinementUpdateRequest>({
      query: ({ maId, id, data }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_DETAILS.replace('{maId}', `${maId}`).replace('{id}', `${id}`),
        method: API_METHODS.patch,
        body: data,
      }),
      invalidatesTags: [],
    }),
    getChartData: build.query<IBaseQueryResponse<IChartItem[]>, IChartRequest>({
      query: ({
        maId, topicId, valueChainMapId,
      }) => ({
        url: MATERIALITY_QUESTIONNAIRE_CHARTS.replace('{maId}', `${maId}`),
        params: {
          ...(topicId ? { topicId } : { }),
          ...(valueChainMapId ? { valueChainMapId } : { }),
        },
      }),
    }),
    getQuestionnaireData: build.query<IBaseQueryPaginationResponse<IQuestionnaireItem[]>, IQuestionnaireRequest>({
      query: ({
        maId, topicId, offset, valueChainMapId,
      }) => ({
        url: MATERIALITY_QUESTIONNAIRE,
        params: {
          ...(topicId ? { topicId } : { }),
          ...(maId ? { maId } : { }),
          ...(offset ? { offset } : { offset: 0 }),
          ...(valueChainMapId ? { valueChainMapId } : { }),
          status: QUESTIONNAIRE_STATUS.SUCCESS,
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
    }),
    getQuestionnaireDetails: build.query<IBaseQueryResponse<IQuestionnaireDetailsItem>, IChartRequest>({
      query: ({
        maId, topicId,
      }) => ({
        url: MATERIALITY_QUESTIONNAIRE_DETAILS.replace('{id}', `${topicId}`),
        params: {
          ...(maId ? { maId } : { }),
        },
      }),
    }),
    getRecipientList: build.query<
    IBaseQueryPaginationResponse<IRespondentRequest[]>, IRecipientRequest>({
      query: ({
        companyId, offset, keyword,
      }) => ({
        url: MATERIALITY_RESPONDENT_LIST,
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
          ...(companyId ? { companyId } : { }),
          ...(keyword ? { keyword } : { }),
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: MATERIALITY_RESPONDENT_LIST_TAG, id } as const)),
          MATERIALITY_RESPONDENT_LIST_TAG]
          : [MATERIALITY_RESPONDENT_LIST_TAG]
      ),
    }),
    createRecipientUsers: build.mutation <IBaseQueryResponse<IRespondentRequest>
    , IRecipientCreateRequest>({
      query: (data) => ({
        url: MATERIALITY_RESPONDENT_CREATE_USERS,
        method: API_METHODS.post,
        body: data,
      }),
      invalidatesTags: [MATERIALITY_RESPONDENT_LIST_TAG],
    }),
    getRefinementQuestions: build.query<
    IBaseQueryPaginationResponse<IStakeholderGroupsQuestionsItem[]>, IRefinementQuestionRequest>({
      query: ({
        maId, offset, id,
      }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_QUESTIONS.replace('{maId}', `${maId}`).replace('{id}', `${id}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
    }),
    getRefinementDisclosures: build.query<
    IBaseQueryPaginationResponse<IStakeholderGroupsDisclosuresItem[]>, IRefinementQuestionRequest>({
      query: ({
        maId, offset, id,
      }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_DISCLOSURES.replace('{maId}', `${maId}`).replace('{id}', `${id}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
    }),
    getRefinementQuestionsCompanies: build.query<IBaseQueryResponse<IRefinementListItem>, IRefinementQuestionRequest>({
      query: ({
        maId, id,
      }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_QUESTIONS_COMPANIES.replace('{maId}', `${maId}`).replace('{id}', `${id}`),
      }),
    }),
    getRefinementDisclosuresRegions: build.query<IBaseQueryResponse<IRefinementListItem>, IRefinementQuestionRequest>({
      query: ({
        maId, id,
      }) => ({
        url: MATERIALITY_TOPIC_REFINEMENT_DISCLOSURES_REGIONS.replace('{maId}', `${maId}`).replace('{id}', `${id}`),
      }),
    }),
    requestReviewMA: build.mutation <null, { id: number }>({
      query: ({ id }) => ({
        url: MATERIALITY_ASSESSMENT_REQUEST_REVIEW.replace('{id}', `${id}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG],
    }),
    approveMA: build.mutation <null, { id: number }>({
      query: ({ id }) => ({
        url: MATERIALITY_ASSESSMENT_APPROVE.replace('{id}', `${id}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG],
    }),
    rejectMA: build.mutation <null, { id: number }>({
      query: ({ id }) => ({
        url: MATERIALITY_ASSESSMENT_REJECT.replace('{id}', `${id}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG],
    }),
    getEmployeesEnumList: build.query<IBaseQueryResponse<IEmployeesEnumItem[]>, { name: string }>({
      query: ({ name }) => ({
        url: MATERIALITY_ASSESSMENT_ENUM,
        params: {
          name,
        },
      }),
    }),
  }),
});

export const {
  useGetMaterialityAssessmentsQuery,
  useDeleteMaterialityAssessmentMutation,
  useCreateMAInitialMutation,
  useUpdateMAMutation,
  useGetSingleMAInitiateQuery,
  useGetMaterialityStakeholdersQuery,
  useUpdateMaterialityStakeholdersMutation,
  useDeleteMaterialityStakeholderMutation,
  useGetMaterialitySHInvestorsQuery,
  useCreateMaterialitySHInvestorsMutation,
  useUpdateMaterialitySHInvestorsMutation,
  useGetMaterialitySHBoardsQuery,
  useCreateMaterialitySHBoardsMutation,
  useUpdateMaterialitySHBoardsMutation,
  useGetMaterialitySHEmployeesQuery,
  useCreateMaterialitySHEmployeesMutation,
  useUpdateMaterialitySHEmployeesMutation,
  useGetMaterialitySHCommunitiesQuery,
  useCreateMaterialitySHCommunitiesMutation,
  useUpdateMaterialitySHCommunitiesMutation,
  useGetMaterialitySHNgosQuery,
  useCreateMaterialitySHNgosMutation,
  useUpdateMaterialitySHNgosMutation,
  useGetMaterialitySHMediaQuery,
  useCreateMaterialitySHMediaMutation,
  useUpdateMaterialitySHMediaMutation,
  useGetGeoRiskListQuery,
  useCreateGeoRiskMutation,
  useDeleteGeoRiskMutation,
  useGetGeoRiskCategoriesListQuery,
  useUpdateAIGeoRiskMutation,
  useGetGeoRiskAnalyzeListQuery,
  useGetGeoRiskGroupsQuery,
  useGetGeoRiskAffectedGroupsQuery,
  useSaveSelectedSupplierMutation,
  useGetStakeholdersSuppliersListQuery,
  useSupplierMACreateMutation,
  useGetStakeholdersCustomersListQuery,
  useSaveSelectedCustomerMutation,
  useCustomerMACreateMutation,
  useGetStakeholdersGroupsQuestionsListQuery,
  useGetStakeholdersQuestionsListQuery,
  useLazyGetStakeholdersQuestionsListQuery,
  useImportQuestionsExcelMutation,
  useCheckGroupQuestionsMutation,
  useCreateQuestionsMutation,
  useGetSectorRiskAnalyzeListQuery,
  useLazyGetSectorRiskAnalyzeListQuery,
  useGetCompanySearchQuery,
  useLazyGetCompanySearchQuery,
  useGetCompanyDetailsCompetitorQuery,
  useLazyGetCompanyDetailsCompetitorQuery,
  useGetStakeholdersCompetitorsListQuery,
  useCompetitorMACreateMutation,
  useDeleteCompetitorMAMutation,
  useUpdateUsersJobMAMutation,
  useUpdateStatusMAMutation,
  useGetStakeholdersAnalysisListQuery,
  useAnalysisAICreateMutation,
  useDeleteVCMaterialityStakeholderMutation,
  useStakeholderAnalysisUpdateMutation,
  useGetStakeholdersGroupsDisclosuresListQuery,
  useGetStakeholdersDisclosuresListQuery,
  useLazyGetStakeholdersDisclosuresListQuery,
  useImportDisclosuresExcelMutation,
  useCheckGroupDisclosuresMutation,
  useCreateDisclosureMutation,
  useGetIROTemplatesListQuery,
  useSelectedIROTemplatesMutation,
  useGetIROImpactListQuery,
  useCreateCustomIROTemplatesMutation,
  useUpdateCustomIROTemplatesMutation,
  useDeleteCustomIROTemplatesMutation,
  useGetIRORisksListQuery,
  useDuplicateImpactTemplatesMutation,
  useCreateCustomRisksTemplatesMutation,
  useUpdateCustomRiskTemplatesMutation,
  useDeleteCustomRiskTemplatesMutation,
  useGetIROOpportunitiesListQuery,
  useGetIROEmailsListQuery,
  useCreateCustomOpportunitiesTemplatesMutation,
  useUpdateCustomOpportunitiesTemplatesMutation,
  useDeleteCustomOpportunitiesTemplatesMutation,
  useResendEmailMutation,
  useDownloadQuestionsQuery,
  useLazyDownloadQuestionsQuery,
  useDownloadDisclosuresQuery,
  useLazyDownloadDisclosuresQuery,
  useGetStateAIGeoRiskQuery,
  useRefreshAIGeoRiskMutation,
  useGetIROScoreListQuery,
  useShareIroQuestionsMutation,
  useIROLinkCreateMutation,
  useIroAnswersCreateMutation,
  useGetStateTopicRefinementQuery,
  useGetStateTopicRefinement2Query,
  useGetStateTopicRefinement3Query,
  useUpdateTopicRefinementMutation,
  useUpdateTopicRefinement2Mutation,
  useUpdateTopicRefinement3Mutation,
  useGetTopicRefinementListQuery,
  useUpdateToggleTopicRefinementMutation,
  useGetChartDataQuery,
  useGetQuestionnaireDataQuery,
  useGetQuestionnaireDetailsQuery,
  useLazyGetQuestionnaireDetailsQuery,
  useGetRecipientListQuery,
  useCreateRecipientUsersMutation,
  useInitializeMAInitialMutation,
  useGetRefinementQuestionsQuery,
  useGetRefinementDisclosuresQuery,
  useGetRefinementQuestionsCompaniesQuery,
  useLazyGetRefinementQuestionsCompaniesQuery,
  useGetRefinementDisclosuresRegionsQuery,
  useLazyGetRefinementDisclosuresRegionsQuery,
  useRequestReviewMAMutation,
  useApproveMAMutation,
  useRejectMAMutation,
  useGetEmployeesEnumListQuery,
} = materialAssessmentApi;
